<div [ngClass]="{ 'sam-border-bottom': ici.value !== 0 && (IsBaseIci$ | async) && (isExpanded$ | async) }"></div>

<div class="ici sam-full-width">
   <div class="type sam-form-flex-row">
      <samweb-text-with-overflow-tooltip
         class="sam-flex-auto text-style"
         [value]="ici.translation | translate"
      ></samweb-text-with-overflow-tooltip>
   </div>
   <div class="greeting">
      <!-- Note: Needed to be put outside, otherwise won't display on some scenarios -->
      <samweb-drop-container
         *ngIf="!(isConfigConflicting$ | async); else conflict"
         [zoneId]="dropZone$ | async"
         [draggedItemKey]="draggedItemKey?.id"
         [hasContent]="!(wave$ | isNil | async)"
         (dropListDroppedId)="dropListDroppedId($event)"
      >
         <div dropPreview>
            <samweb-agent-greeting-wave
               dragPlaceHolder
               *ngIf="!(draggedItemKey | isNil | async)"
               class="sam-full-width"
               [wave]="draggedItemKey"
               [displayClear]="false"
            >
            </samweb-agent-greeting-wave>
         </div>
         <div itemContent class="sam-full-width">
            <samweb-agent-greeting-wave
               class="sam-full-width"
               *ngIf="!(wave$ | isNil | async) && !(isConfigConflicting$ | async)"
               [wave]="wave$ | async"
               [searchValues]="searchValues"
               [tooltipTranslation]="'common.remove'"
               [displayClear]="!disabled"
               (removeWave)="clear($event)"
            >
            </samweb-agent-greeting-wave>
         </div>
      </samweb-drop-container>
   </div>
</div>

<ng-template #conflict>
   <div
      class="sam-no-margin sam-no-padding conflict-box-style"
      (mouseenter)="isMouseOverComponent = true"
      (mouseleave)="isMouseOverComponent = false"
   >
      <samweb-dialog-tooltip class="sam-full-width" [isDialogOpen]="isMouseOverComponent" itemContent>
         <div class="sam-center sam-clickable sam-form-flex-row" (click)="expandIciGroup()">
            <fa-layers class="conflict" [fixedWidth]="true">
               <fa-icon [icon]="conflictIcon"></fa-icon>
               <fa-layers-counter class="counter" content="{{ configuredWaveCount$ | async }}"></fa-layers-counter>
            </fa-layers>
            <div class="sam-margin-left-medium sam-ellipsis-on-overflow">
               {{ 'common.settings.agent_greetings.conflicting_wave_configuration_item' | translate }}
            </div>
         </div>
         <div dialog class="sam-margin sam-form-row conflict-dialog">
            <div class="sam-margin">
               <div class="sam-margin sam-auto-overflow">
                  <div class="sam-form-flex-row sam-margin" *ngFor="let assignedFile of getAudioFilesForGroup$ | async">
                     <div class="conflict-ici">{{ assignedFile?.iciName | translate }}</div>

                     <samweb-agent-greeting-wave
                        *ngIf="!(assignedFile?.wave | isNil | async)"
                        class="sam-flex-auto conflict-wave"
                        [wave]="assignedFile?.wave"
                        [displayClear]="false"
                     >
                     </samweb-agent-greeting-wave>
                     <div
                        class="sam-margin-left sam-italic sam-form-flex-row sam-opacity-light"
                        *ngIf="assignedFile?.wave | isNil | async"
                     >
                        <fa-icon [icon]="notAssignedIcon" [fixedWidth]="true"></fa-icon>

                        <div class="sam-margin-left-large">
                           {{ 'common.settings.agent_greetings.not_assigned' | translate }}
                        </div>
                     </div>
                  </div>
               </div>
               <div class="sam-margin"></div>
            </div>
         </div>
      </samweb-dialog-tooltip>
   </div>
</ng-template>
